import { lang } from 'enablex/shared'
import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from 'react-router'
import { Redirect } from 'react-router-dom'
import api from '~/app/api'

import BasicAuthentication from '~/auth/basicAuth'
import { ChangePasswordForm } from './ChangePasswordForm'
import LoginContainer from './LoginContainer'

type RouterProps = RouteComponentProps<undefined, {}, { email: string; password: string; loginUrl: string }>
type Props = { auth: BasicAuthentication } & RouterProps

export const ChangePassword: FC<Props> = props => {
  const [domainLogo, setDomainLogo] = useState('')
  const [domainWorkspace, setDomainWorkspace] = useState('')
  const [error, setError] = useState<string>()
  const { email, password, loginUrl } = props.location.state

  const updatePassword = async (newPassword: string, confirmPassword: string) => {
    if (newPassword !== confirmPassword) {
      return setError(lang.tr('admin.passwordsDontMatch'))
    }

    try {
      setError(undefined)
      await props.auth.login({ email, password, newPassword }, loginUrl)
    } catch (err) {
      setError(err.message)
    }
  }

  const fetchBranding = async () => {
    const response = await api.getAnonymous().get<any>('/admin/auth/branding')
    const {payload} = response.data
    if(payload.result === true) {
      setDomainLogo(payload.branding?.logoURL || '')
      setDomainWorkspace(payload.workspaceId)
    } else {
      setDomainLogo('')
      setDomainWorkspace('')
    }
  }
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetchBranding()
  }, [])

  const subtitle = password === '' ? lang.tr('admin.firstTimeYouRun') : lang.tr('admin.setANewPassword')

  if (props.auth.isAuthenticated() || !email || !loginUrl) {
    return <Redirect to="/" />
  }

  return (
    <LoginContainer subtitle={subtitle} error={error} title='Setup New Password' domainLogo={domainLogo} domainWorkspace={domainWorkspace}>
      <ChangePasswordForm onChangePassword={updatePassword} email={email} />
    </LoginContainer>
  )
}

export default ChangePassword
